import { VariantInfo } from '../../product/types';
import { BasicApplicationInfoRecord } from '../../application/types';

export const isSolutionProvider = (record?: VariantInfo | BasicApplicationInfoRecord) => {
  return record?.companyContactInfo.creatingCompany?.solutionProvider;
};
